import Popover from 'antd/lib/popover';
import Typography from 'antd/lib/typography';
import { CircleIcon } from '../../../../components/icons/icons';
import { IEventContext } from '../../../../domain/event/interface';
import { getComputerFormattedTime } from '../../../../domain/date/date';
import { VEN_STATUS_COLOR_MAP, VenStatus } from '../../../../domain/ven/interface';

const { Text } = Typography;

interface IEventResourceStatusCellProps {
    value: IEventContext['resource_telemetry_status'] | null;
}

export const EventResourceStatusCell = ({ value }: IEventResourceStatusCellProps) => {
    if (!value) return <></>;

    const venStatus = value.status === 'online' ? VenStatus.ONLINE : VenStatus.OFFLINE;
    const color = VEN_STATUS_COLOR_MAP[venStatus];

    const lastSeenString = value.last_reported ? getComputerFormattedTime(new Date(value.last_reported)) : null;

    const content = (
        <div style={{ maxWidth: '350px' }}>
            <div className="device-icon-popover-title">
                Resource Status <small>(at the event creation moment)</small>
            </div>
            <div className="device-icon-popover-status">
                <Text type={venStatus === VenStatus.ONLINE ? 'success' : 'danger'}>{venStatus.toUpperCase()}</Text>
            </div>
            {lastSeenString && <div className="device-icon-popover-lastseen">Last seen:&nbsp;{lastSeenString}</div>}
            <div>
                VEN ID:&nbsp;<b>{value.ven_id}</b>
            </div>
            <div>
                Resource ID:&nbsp;<b>{value.resource_id}</b>
            </div>
        </div>
    );

    return (
        <span style={{ display: 'inline-block', position: 'relative', width: 32, height: 32, verticalAlign: 'middle' }}>
            <Popover content={content}>
                <CircleIcon style={{ fontSize: '28px', color }} />
            </Popover>
        </span>
    );
};
